<h2 mat-dialog-title>Prorogare messaggio?</h2>
<hr>
<form name="scadenzaForm" [formGroup]="scadenzaForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
        <span>Scadenza attuale: {{ scadenza_attuale | date:"EEEE dd/LL/y  HH:mm" }} </span> <br>
        <hr>
        <!-- <span>Inserire nuova scadenza: </span> -->
            <div class="dateTime-container">
                <mat-form-field class="scadenza-date-field">
                    <mat-label>Nuova scadenza</mat-label>
                    <input matInput formControlName="scadenza_data" [matDatepicker]="picker2" required>
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>    
                <ngx-timepicker-field class="scadenza-time-field" [format]="24" [controlOnly]="true" [defaultTime]="'23:59'"
                formControlName="scadenza_tempo" required></ngx-timepicker-field>
            </div>

            <div *ngIf="scadenzaForm.errors && (scadenzaForm.dirty || scadenzaForm.touched)" class="alert alert-danger">
                <!-- {{ scadenzaForm.errors | json }} -->
                <div *ngIf="scadenzaForm.hasError('endDate')">
                    Nuova scadenza non valida.
                </div>
                <div *ngIf="scadenzaForm.hasError('required')">
                    Questo campo è necessario.
                </div>
            </div>
            
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions id="action-div">
        <button mat-stroked-button [mat-dialog-close]="'cancel'">Annulla</button>
        <!-- <button type="submit" [disabled]="!scadenzaForm.valid" mat-stroked-button color="primary" (click)="closeExtending()">Proroga</button> -->
        <button [disabled]="scadenzaForm.errors && (scadenzaForm.dirty || scadenzaForm.touched)" type="submit" mat-stroked-button color="primary" (click)="closeExtending()">Proroga</button>
    </mat-dialog-actions>
</form>